import {TabProps, Tabs} from 'platform/components';
import {Show} from 'platform/foundation';

import {not} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetTransferOrderQuery} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {queryParams, Section, usePermissions} from '@dms/shared';
import {useWarehouseParams} from '@dms/warehouse/shared-components';

import {useBoolean, useQueryState} from 'shared/web';

import {GeneralInformationTab} from './components/GeneralInformationTab';
import {ListOfItemsTab} from './components/ListOfItemsTab';
import {TransferOrderMaterialModal} from './components/TransferOrderMaterialModal';

export function Overview() {
  const {transferOrderId} = useWarehouseParams();

  const isDraft = isNilOrEmpty(transferOrderId);

  const [canEditTransferOrder] = usePermissions({
    permissionKeys: ['transferOrderEdit'],
  });

  const [activeTabId, setActiveTabId] = useQueryState(queryParams.COMPONENT_SECTIONS_TAB);

  const [isMaterialModalVisible, openMaterialModal, closeMaterialModal] = useBoolean();

  const transferOrderQuery = useGetTransferOrderQuery(
    {transferOrderId},
    {skip: isNilOrEmpty(transferOrderId)}
  );

  const isInTransfer = transferOrderQuery.data?.state === 'TRANSFER';

  const isCompleted = transferOrderQuery.data?.state === 'COMPLETED';

  const tabs: TabProps[] = [
    {
      id: 'general-information',
      title: i18n.t('entity.warehouse.labels.generalInformation'),
      content: <GeneralInformationTab />,
    },
    {
      isDisabled: isDraft,
      id: 'list-of-items',
      title: i18n.t('entity.warehouse.labels.listOfItems'),
      content: <ListOfItemsTab />,
      actions: [
        {
          isDisabled: not(canEditTransferOrder) || isInTransfer || isCompleted,
          type: 'button',
          variant: 'outlined',
          title: i18n.t('entity.warehouse.labels.addMaterial'),
          onClick: openMaterialModal,
        },
      ],
    },
  ];

  return (
    <Section isFullHeight>
      <Tabs
        isLazy
        isFullHeight
        tabs={tabs}
        activeTabId={activeTabId}
        onChange={setActiveTabId}
        variant="condensed"
      />
      <Show when={isMaterialModalVisible}>
        <TransferOrderMaterialModal
          transferOrderId={transferOrderId}
          onActionClick={closeMaterialModal}
        />
      </Show>
    </Section>
  );
}
